module.exports = __webpack_public_path__ + "img/new_logo_trans.e19df3e.png";